// Copyright © 2021 Move Closer
export const PdfServiceType = Symbol.for('IPdfService');
